import React, { useEffect, useState } from "react";
import { useLoadingMessageStore } from "../../../../store/loadingMessageStore";
import LoadingGIF from "../../../../assets/img/GIF/Loading-Gif.gif";
import {useViewerStore} from "../../../../store/store";
import { useCurrentUser } from "../../../../contexts/UserContext";

const SiteLoadLoader: React.FC = () => {
    const loadingMessages = useLoadingMessageStore(state => state.loadingMessages);  
    const pathname = useViewerStore(state => state.pathname);
    const isRightSidebarOpen = useViewerStore((state) => state.isRightSidebarOpen);
    const isExpandPopup = useViewerStore((state) => state.isExpandPopup);
    const [rightClass, setRightClass] = useState("")
    const { hasCapability } = useCurrentUser();
    const isViewportOnlyEmbed = useViewerStore((state) => Boolean(state.isViewportOnlyEmbed));
    let title, message, isStatusLoader;
    if (loadingMessages.length > 0) {
        const firstMessage = loadingMessages[loadingMessages.length - 1];
        title = firstMessage.title;
        message = firstMessage.message;
        isStatusLoader = firstMessage.inBackground ?? false;
    }

    const active = !!(title || message);
    useEffect(() => {
        const popupBtn = document.getElementsByClassName("float_button")[0];
        if (!popupBtn) {
            setRightClass(!isRightSidebarOpen? "popuphide":"popuphide-sidebar");
            return;
        }
        const position = isExpandPopup && isRightSidebarOpen
            ? "expand-sidebar"
            : isExpandPopup && !isRightSidebarOpen
            ? "expand"
            : pathname === "/configure/roof" && isRightSidebarOpen
            ? "labledbtn-sidebar" 
            : pathname === "/configure/roof" && !isRightSidebarOpen
            ? "labledbtn"
            : isRightSidebarOpen
            ? "iconbtn-sidebar"
            :"iconbtn"
        setRightClass(position);
    }, [isExpandPopup, pathname, isStatusLoader, isRightSidebarOpen]);

    return (
        (isStatusLoader
            ? 
            <div  className={`status-bar ${!active ? 'hide' : ''} ${rightClass}`} >
                <div>
                    <img src={LoadingGIF} height={20} alt="Loading..." />
                    <span style={{paddingLeft:'10px'}} >{message}</span>
                </div>
            </div>
            : 
            <div className={`loading-page-back ${!active ? 'hide' : ''}`}>
                <img src={LoadingGIF} height={50} alt="Loading..." />
                <br />
                <h1 style={{ color: "white" }}>{title ?? 'Loading...'}</h1>
                <br />
                <div className="loading-page-back__message">{message}</div>
                { hasCapability('Show_OneButton') && !isViewportOnlyEmbed && (
                <button
                    type="button"
                    onClick={() => useViewerStore.setState({ isDashboardOpen: true })}
                    style={{
                        marginTop: 16,
                        padding: '8px 14px',
                        borderRadius: 8,
                        border: '1px solid rgba(148,163,184,0.45)',
                        background: 'rgba(15,23,42,0.65)',
                        color: '#e2e8f0',
                        cursor: 'pointer',
                    }}
                >
                    Switch to dashboard
                </button>
                )}
            </div>)
    );
}

export default SiteLoadLoader;
